import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.claim}claimGroups/${COMMON_QUERY_PARAMS.CLAIM_GROUP_ID}/reason`;

interface ClaimReasonPayload {
  claimId: string;
  reasonId: string;
  declareSafetyRisk?: boolean;
}

interface SetClaimGroupReasonCommandPayload {
  claimGroupId: string;
  claimsReason?: ClaimReasonPayload[];
}

export const setClaimGroupReasonCommand = async ({
  claimGroupId,
  claimsReason,
}: SetClaimGroupReasonCommandPayload): Promise<
  BaseBackResponse | BackResponseFailure
> => {
  try {
    const url = ENDPOINT.replace(
      COMMON_QUERY_PARAMS.CLAIM_GROUP_ID,
      claimGroupId,
    );

    const response = await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.PUT,
      json: {
        claimsReason,
      },
    });

    return response;
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
};
